import { extractFile } from './index';
import {EXPORT_OLD_QUATERLY_REPORT, OLD_QUATERLY_REPORT_ERROR} from './types';



export function extractOldQuaterlyReport(documentId) {
    const url = '/oldQuaterlyReport/extract/'+documentId;
    return dispatch => extractFile(EXPORT_OLD_QUATERLY_REPORT, OLD_QUATERLY_REPORT_ERROR, true, url, dispatch);
  }